/** Build-time switches, set per environment in `.env.<mode>`. Anything unset is off. */

/** A product's Incidents tab and its dashboard card: still in development, so off outside local dev. */
export const isProductIncidentsEnabled = (): boolean => import.meta.env.VITE_PRODUCT_INCIDENTS === 'true';
